// extracted by mini-css-extract-plugin
module.exports = {"navItemActive":"top-posts-module--nav-item-active--2IdSD"};